<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_499_3826)">
                <path
                    d="M22.832 6.87238H14.9448C14.149 5.63524 13.097 4.58325 11.8599 3.78742L12.5283 1.49426L9.61813 6.87238H1.0625C3.39103 7.75623 5.62933 8.86161 7.74658 10.1733L2.1011 20.3742L11.9421 13.9678C13.7189 15.9614 15.348 18.082 16.8164 20.3125C17.5312 17.1953 17.496 13.9529 16.7135 10.852L22.832 6.87238ZM11.757 3.94167C12.5292 4.8121 13.1169 5.83008 13.4846 6.93408H10.7596L11.757 3.94167ZM1.92629 7.02663L8.93943 7.63334L8.19904 9.03185L1.92629 7.02663ZM7.64375 14.667L9.07312 11.0268C9.79598 11.4604 10.4596 11.9857 11.0475 12.5898L7.64375 14.667ZM9.61813 9.72083L10.4614 7.72589L13.9062 7.9007L14.7597 10.3378L12.5077 11.5512L9.61813 9.72083ZM13.8445 12.7544L15.0682 12.0551L15.243 14.4305L13.8445 12.7544ZM15.6749 7.9624L18.1532 8.1475L16.2097 9.40205C16.0575 8.91288 15.879 8.4323 15.6749 7.9624Z"
                    :fill="color" 
                />
            </g>
            <defs>
                <clipPath id="clip0_499_3826">
                    <rect width="23" height="20" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAsae',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>